import React, { FC } from "react";

import { MAX_SHEET_INDEX } from "../index";

import styles from "./Indicator.module.scss";

type Props = {
  index: number;
};

const Indicator: FC<Props> = ({ index }) => {
  return (
    <div
      className={styles.indicator}
      style={{
        transform: `scaleX(${index / MAX_SHEET_INDEX})`,
      }}
    />
  );
};

export default Indicator;
